import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  ITimezoneInitialState,
  ISetTimezoneListPayload
} from "./timezoneReducerTypes";

const timezoneInitialState: ITimezoneInitialState = {
  timezones: [],
  isLoading: false,
  errorMessage: '',
};

const timezoneSlice = createSlice({
  name: 'timezone',
  initialState: timezoneInitialState,
  reducers: {
    getTimezoneList(state) {
      state.isLoading = true;
      state.errorMessage = '';
    },
    setTimezoneList(state, {payload}: PayloadAction<ISetTimezoneListPayload>) {
      state.timezones = payload.timezones;
      state.isLoading = false;
      state.errorMessage = '';
    },
    setTimezoneListError(state, {payload}: PayloadAction<{errorMessage: string}>) {
      state.isLoading = false;
      state.errorMessage = payload.errorMessage;
    },
  },
});

export const {
  getTimezoneList,
  setTimezoneList,
  setTimezoneListError,
} = timezoneSlice.actions;

export default timezoneSlice.reducer;

